import {
  TemplateStateActions,
  useDesignerDataContext,
} from '../../../../hooks/useDesignerLogic';
import { GeneratorTabState } from '../../../../hooks/useDesignerUIState';
import { Slide } from '../../../SlideComponents/slide.types';
import { findRelatedSlidesWithoutIndex } from '../../../SlideComponents/slideUtil';
import { makeNewIdsForSlide } from '../../../SlideComponents/slideUtilCopyPaste';
import CoreAddSlidesExperience from '../CoreAddSlidesExperience';

const GeneratorSelectSlides = ({
  onAddActivity,
  generatorTabState,
  setGeneratorTabState,
}: {
  onAddActivity: (rounds: Slide[]) => void;
  generatorTabState: GeneratorTabState;
  setGeneratorTabState: (generatorTabState: GeneratorTabState) => void;
}) => {
  const dispatch = useDesignerDataContext(c => c.dispatch);
  const handleAddRounds = (rounds: Slide[]) => {
    const newSelectedAIGeneratedRounds = makeNewIdsForSlide(
      rounds.flatMap(round => {
        const related = findRelatedSlidesWithoutIndex(
          round.id,
          generatorTabState.generatedSlides || [],
        );
        return related;
      }),
    );

    if (generatorTabState.generatedAttachments) {
      // Save attachments to the lesson.
      generatorTabState.generatedAttachments.forEach(attachment => {
        dispatch({
          type: TemplateStateActions.attachmentUpserted,
          attachment,
        });
      });
    }

    onAddActivity(newSelectedAIGeneratedRounds);
    setGeneratorTabState({
      ...generatorTabState,
      isLoadingGeneratedRounds: false,
      isErrorGeneratedRounds: undefined,
    });
  };

  return (
    <CoreAddSlidesExperience
      rounds={generatorTabState.generatedSlides}
      title={'Back to refine your instructions'}
      isDiscoverTemplate={false}
      metricsContext={{
        ...generatorTabState,
        tab: 'GeneratorTab',
      }}
      onGoBack={() => {
        setGeneratorTabState({
          ...generatorTabState,
          generatedSlides: [],
          isLoadingGeneratedRounds: false,
          isErrorGeneratedRounds: undefined,
        });
      }}
      onAddRounds={handleAddRounds}
      generatorTabState={generatorTabState}
      isGeneratorTab={true}
      setGeneratorTabState={setGeneratorTabState}
      isOwner={true}
    />
  );
};

export default GeneratorSelectSlides;
